<oui-checkbox [label]="optionAuto.libelle" [control]="control" labelStyle="body-1"></oui-checkbox>
